const colors = [
  "#fe4a49",
  "#2ab7ca",
  "#f6abb6",
  "#03396c",
  "#651e3e",
  "#fe8a71",
  "#009688",
]

function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max))
}

export function getRandomColor() {
  return colors[getRandomInt(colors.length)]
}

export function getColor(pos) {
  return colors[pos]
}